// OrientationGate — play 画面が portrait の時だけ children を CSS で 90°回転し、横長キャンバスとして描画する。
// 旧実装 (横画面プロンプト + visibility:hidden 退避) は廃止。回転プロンプトは「OS の向きロック解除」を
// ユーザに強いる最悪 UX だったため、ここでは縦持ちのまま中身を回して正立させる (OS ロックは触らない)。
//   - active && portrait  → children を .force-landscape ラッパに入れて 90°回転 (横長キャンバス化)。
//   - それ以外 (横向き / 非 play) → children をそのまま素描画 (回転なし)。
// children は常に同一ツリーで mount されたまま (回転 on/off は外側 div のクラス差し替えのみ) → 状態保持。
// data-forced は theme.css の [data-forced] スコープ override (内部 dvh→% リコンサイル) の起点。
import { type ReactNode } from 'react';
import { useOrientation } from '../ui/orientation';

export interface OrientationGateProps {
  active: boolean; // 回転を効かせる対象か (= screen==='play')
  children: ReactNode; // 対局 DOM (常に mount)
}

export function OrientationGate({ active, children }: OrientationGateProps) {
  const orient = useOrientation();
  const forced = active && orient === 'portrait';

  // forced のときだけ .force-landscape (position:fixed で viewport を 90°swap) に入れる。
  // 直下の子 (= 対局サーフェスのルート) は theme.css 側で width/height:100% に解決され横長キャンバスを満たす。
  if (forced) {
    return (
      <div className="force-landscape" data-forced="">
        {children}
      </div>
    );
  }
  // 素描画: 親 flex を満たす列として振る舞う (従来の縦/横レイアウト)。
  return <div className="play-surface-wrap">{children}</div>;
}
